import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";
import { api, errMsg, TOKEN_KEY } from "@/lib/api";

export const DeleteAccountDialog = ({ open, onOpenChange }) => {
  const { setUser } = useAuth();
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.delete("/auth/account", { data: { password } });
      localStorage.removeItem(TOKEN_KEY);
      setUser(false);
      toast.success("Your account and all its data have been deleted.");
      navigate("/login");
    } catch (err) { toast.error(errMsg(err)); } finally { setBusy(false); }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md" data-testid="delete-account-dialog">
        <DialogHeader>
          <DialogTitle className="font-heading text-red-600">Delete your account?</DialogTitle>
          <DialogDescription>This permanently removes your business, all clients, invoices, expenses, receipts and logo, and cancels any subscription. It cannot be undone.</DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-4">
          <div className="space-y-1.5">
            <Label>Type <span className="font-mono font-bold">DELETE</span> to confirm</Label>
            <Input data-testid="delete-account-confirm-input" value={confirm} onChange={(e) => setConfirm(e.target.value)} autoComplete="off" />
          </div>
          <div className="space-y-1.5">
            <Label>Your password</Label>
            <Input data-testid="delete-account-password-input" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} />
          </div>
          <div className="grid grid-cols-2 gap-3">
            <Button type="button" variant="outline" onClick={() => onOpenChange(false)} disabled={busy} data-testid="delete-account-cancel-button">Keep my account</Button>
            <Button type="submit" disabled={busy || confirm !== "DELETE" || !password} className="bg-red-600 hover:bg-red-700 text-white font-bold" data-testid="delete-account-submit-button">
              {busy ? "Deleting..." : "Delete everything"}
            </Button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
};
